function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2 6a2 2 0 012-2h12a2 2 0 012 2v7a2 2 0 01-1.164 1.818 1.497 1.497 0 00-.275-.379l-.446-.446A1 1 0 0017 13V6a1 1 0 00-1-1H4a1 1 0 00-1 1v7a1 1 0 001 1h5v1H4a2 2 0 01-2-2V6zm8.854 4.146A.5.5 0 0010 10.5v7a.5.5 0 00.91.287l1.571-2.245 2.943.452a.5.5 0 00.43-.848l-5-5zM11 15.915v-4.207l3.066 3.067-1.74-.268a.5.5 0 00-.486.207l-.84 1.2z"
});

function SvgAddButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgAddButton;